import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Aspire Academy';
const SITE_URL = 'https://academy-website-alpha.vercel.app';
const DEFAULT_DESCRIPTION = 'Sri Lanka\'s premier IGCSE and A Level tuition center in Colombo 7. Expert tutors, small batch sizes, Cambridge & Edexcel syllabi. Achieve A*/A grades with Aspire Academy.';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;

const SEO = ({
  title,
  description = DEFAULT_DESCRIPTION,
  path = '',
  image = DEFAULT_IMAGE,
  type = 'website',
  noIndex = false,
}) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | IGCSE & A Level Tuition in Colombo, Sri Lanka`;
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      {/* Primary */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_LK" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Additional SEO */}
      <meta name="geo.region" content="LK-11" />
      <meta name="geo.placename" content="Colombo" />
      <meta name="geo.position" content="6.9128705;79.8571263" />
      <meta name="ICBM" content="6.9128705, 79.8571263" />
    </Helmet>
  );
};

export default SEO;
